import {Box, Flex, FormLabel, Input} from '@chakra-ui/react';
import React, {useState, useRef, useEffect} from 'react';
import {CustomSelect} from '../General/FormInputs';
import {get} from '../../service/ApiService';
import {Group} from '../../service/Urls';
import ErrorHelper from '../../service/ErrorHelper';

// Takes in register, errors, and an id for the form value when page is submitted.
export const GroupSelect = props => {
  const [toast, setToast] = useState('');
  const [groups, setGroups] = useState([]);
  const groupInput = useRef(null);
  const [value, setValue] = useState('');

  useEffect(() => {
    if (props.defaultValue) {
      groupInput.current.value = props.defaultValue;
      getGroups();
    }
  }, [props.defaultValue, props.location]);

  useEffect(() => {
    if (props.disabled) {
      groupInput.current.value = null;
      setGroups([]);
    }
  }, [props.disabled]);

  const getGroups = async () => {
    const data = groupInput.current.value;
    if (data === '') {
      return;
    } else if (data.match(/^[0-9]+$/) && props.clientId) {
      const url = Group.GET_BY_CODE + '?GroupCode=' + data + '&ClientId=' + props.clientId;
      const response = await get(url);
      response.name = response.clCname;
      setGroups([response]);
    } else if (data.toLowerCase().match(/^[a-z]+$/)) {
      const response = await get(Group.GET_BY_NAME + '?GroupName=' + data);
      setGroups(response.data);
    } else {
      // const response = await get(Group.GET_BY_NAME + '?GroupName=' + data);
      // setGroups(response.data);
      setToast({response: {error: true}, errorMessage: 'Can not search by given code.  Please enter numbers or letters to search for groups'});
    }
    // const data = clientInput.current.value;
    // if (data === '') {
    //   return;
    // } else if (data.match(/^[0-9]+$/) && data.length >= 4) {
    //   const response = await get(Client.CLIENT + '/get-by-code?clientCode=' + data);
    //   setClients([response]);
    // } else if (data.toLowerCase().match(/^[a-z]+$/)) {
    //   const response = await get(Client.CLIENT + '/get-by-name?clientName=' + data);
    //   setClients(response.data);
    // } else {
    //   setToast({response: {error: true}, errorMessage: 'Can not search by given code.  Please enter numbers or letters to search for clients'});
    // }
  };

  return (
    <Flex mr="auto" alignContent="bottom">
      <Box mr="1">
        <FormLabel htmlFor="account-rep" mb="-0.5" ml="1" fontSize="sm">
          Select
        </FormLabel>
        <Input ref={groupInput} onBlur={getGroups} placeholder="Group Name" disabled={props.disabled ?? false} />
      </Box>

      <Box w="100%">
        <CustomSelect
          id={props.id}
          register={props.register}
          errors={props.errors}
          value={value}
          onChange={e => setValue(e.target.value)}
          name="Select Group"
          disabled={props.disabled ?? false}
          required={props.required ? props.required : false}
        >
          {groups == []
            ? []
            : groups.map(group => {
                return (
                  <option key={group.id} value={group.id}>
                    {group.grDesc}
                  </option>
                );
              })}
        </CustomSelect>
        <ErrorHelper toastResponse={toast} />
      </Box>
    </Flex>
  );
};
